import { useSelector } from 'react-redux'
import { StoreInterface } from '../../../../../common/types/interfaces'
import { ListItem } from '../item/Item'
import classes from './List.module.sass'
import { selectConnected } from '../../../../../store/slices/wsSlice'

type Props = {
  startEdit: (el: StoreInterface) => void
  showDetails: (el: StoreInterface) => void
  list: StoreInterface[]
  loading: boolean
}

export const List = ({ startEdit, list, showDetails, loading }: Props) => {
  const isConnected = useSelector(selectConnected)
  return (
    <div className={classes.container}>
      {!list?.length && !loading ? (
        <div className={classes.Message}>Нет торговых точек</div>
      ) : (
        list.map((el) => (
          <ListItem el={el} startEdit={startEdit} key={el.id} showDetails={showDetails} isConnected = {isConnected}/>
        ))
      )}
    </div>
  )
}
